
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Busonrentinpuneforcorporate() {



    const cardData =
    {
        keyword: 'Bus On Rent in Pune for Corporate Events',
        heading: 'etravo :  Bus On Rent in Pune for Corporate Events',
        headingDescription: 'eTravo provides top-notch Bus on Rent in Pune for Corporate Events, offering tailored transportation solutions for seminars, conferences, team outings, product launches, and client visits. Our premium fleet includes well-maintained AC and luxury buses equipped with modern amenities to ensure a comfortable and professional experience. With trained chauffeurs, GPS-enabled tracking, and on-time service, we make group travel seamless and stress-free. Whether your event is within Pune or requires outstation travel, eTravo delivers dependable and scalable transport support to elevate your corporate event logistics.',

        top: 'Top Places to Visit in Pune with etravo',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Built in 1732 by the Peshwas of the Maratha Empire, it served as their seat of power until 1818. The grand entrance, known as the Delhi Darwaza, and the intricate architecture reflect the glory of Maratha rule. Although much of the fort was destroyed in a fire in 1828, its remaining walls, gardens, and fountains still echo the stories of royal intrigue, valor, and politics. It is a must-visit for history enthusiasts and those curious about Pune’s regal heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace is not just a stunning piece of architecture but also a monument of national significance. Built in 1892 by Sultan Aga Khan III, the palace is closely associated with India’s freedom movement. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. With its Italian arches, sprawling gardens, and a museum housing Gandhiji’s memorabilia, the palace provides a serene yet powerful reminder of India’s struggle for independence. It’s a place of reflection, peace, and inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, meaning 'Lion's Fort', is perched atop a rugged hill about 35 km from Pune. A site of many historical battles, it is most famous for the Battle of Sinhagad in 1670, where the Maratha warrior Tanaji Malusare fought valiantly. The fort offers panoramic views of the surrounding Sahyadri mountains and the Khadakwasla dam. A favorite among trekkers and nature lovers, the fort also features remnants of ancient gates, temples, military stables, and even food stalls offering local snacks like kanda bhaji and pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple is a hidden gem amidst Pune’s urban sprawl. Carved out of a single basalt rock in the 8th century, this ancient temple is dedicated to Lord Shiva and features beautifully sculpted pillars and a Nandi bull in the courtyard. Despite being in the middle of the bustling Jangli Maharaj Road, the temple offers a peaceful, almost timeless ambiance. Its unfinished structure adds to its mystique, making it a fascinating stop for lovers of history, architecture, and spirituality."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum is a treasure trove of India's rich cultural legacy. Founded by Dr. Dinkar G. Kelkar in memory of his son, the museum houses over 20,000 artifacts that span centuries. From musical instruments and antique furniture to intricate ivory carvings and everyday tools, each item tells a story of India’s diverse traditions and artistry. A full-scale replica of a traditional Maratha wada (mansion) is one of the highlights. Located in central Pune, this museum offers a deep dive into India’s folk and decorative arts."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most beloved and iconic spiritual sites, the Dagdusheth Halwai Ganapati Temple attracts thousands of devotees every day. The temple is known for its magnificent Ganesh idol, adorned with gold and fresh flowers, and its vibrant atmosphere during Ganesh Chaturthi. Built over 130 years ago by a sweet merchant named Dagdusheth Halwai, the temple is not only a center of faith but also a hub for community activities, charity, and cultural events. Its grandeur and spiritual aura make it a must-visit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in the serene Koregaon Park area, the Osho Ashram is a global meditation hub that attracts spiritual seekers from across the world. Founded by the Indian mystic Osho, the resort offers a range of meditation techniques, wellness therapies, and personal growth workshops amidst tranquil Zen-like gardens and modern infrastructure. Visitors can enroll for day passes or longer retreats and enjoy a unique blend of spirituality, luxury, and self-discovery in one of India’s most sophisticated wellness centers."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Inspired by the Korakuen Garden of Okayama, Japan, this beautifully landscaped park, also known as the Pu La Deshpande Udyan, is a symbol of Indo-Japanese friendship. Spread across 10 acres, it features manicured lawns, flowing streams, wooden bridges, and bonsai-style trees. The garden offers a peaceful environment for walking, photography, or quiet contemplation, making it one of the most scenic urban escapes in Pune."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the oldest heritage landmarks in Pune, rising 2,100 feet above sea level. A climb of 103 steps leads you to a group of five temples, the main one dedicated to Goddess Parvati. From the top, visitors are treated to a panoramic view of the entire city. The hill also houses a small museum and the Peshwa-era samadhis (memorials), making it a spiritual and historical site worth visiting—especially during sunrise or sunset."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Situated about 20 km from Pune, Khadakwasla Dam is a peaceful retreat that provides drinking water to the city. Surrounded by hills and greenery, it’s a favorite weekend getaway for picnics, morning walks, and watching the sunset over the backwaters. The area is also popular with cyclists and joggers. On weekends, local food stalls set up shop, offering mouthwatering Maharashtrian snacks, making it a blend of natural beauty and local flavor."
  }
],

"services": [
  {
    "name": "Corporate Event Transportation Pune",
    "description": "eTravo offers specialized corporate event transportation in Pune to ensure timely and professional travel for seminars, product launches, and off-site meetings. Our fleet includes AC coaches, minibuses, and luxury vehicles to suit any group size or event scale. Enjoy seamless coordination, punctual service, and expert logistical support."
  },
  {
    "name": "Luxury Bus Rental for Business Events in Pune",
    "description": "Elevate your corporate event experience with eTravo’s luxury bus rentals in Pune. Our high-end coaches come with reclining seats, air-conditioning, entertainment systems, and professional drivers, making them perfect for transporting executives, clients, or employees to conferences and business functions in style and comfort."
  },
  {
    "name": "AC Buses on Hire for Corporate Occasions Pune",
    "description": "Book eTravo’s AC buses for corporate occasions in Pune and ensure a comfortable commute for your team or guests. Whether it’s an awards ceremony, team outing, or annual meeting, our buses provide clean interiors, climate control, and punctual service to make group travel effortless and pleasant."
  },
  {
    "name": "Executive Bus Rental Pune",
    "description": "eTravo provides executive bus rental services in Pune for high-level corporate travel. Our premium buses feature plush interiors, Wi-Fi, bottled water, and trained chauffeurs—ideal for transporting executives to business events, leadership summits, or off-site meetings with professionalism and ease."
  },
  {
    "name": "Staff Transport for Corporate Functions Pune",
    "description": "Ensure your staff arrives on time and stress-free to corporate functions with eTravo’s dedicated transport services in Pune. We offer shuttle solutions for large gatherings, ensuring timely pickups, fixed routes, and full-day rental options to accommodate your event schedule."
  },
  {
    "name": "Professional Event Commute Pune",
    "description": "eTravo ensures smooth and professional commuting for corporate events in Pune. Our transport solutions cover pickup/drop coordination, group logistics, and multi-location routing. With a fleet of buses and minibuses, we’re equipped to manage events of any scale efficiently and professionally."
  },
  {
    "name": "Business Conference Bus Services Pune",
    "description": "Simplify your business conference logistics with eTravo’s bus services in Pune. Our modern fleet supports single or multi-day conferences, offering route optimization, guest coordination, and on-site support. Our team works closely with event planners to ensure smooth group movements at every stage."
  }
],
"tableData": [
  ["Corporate Event Transportation Pune", "Luxury Bus Rental for Business Events in Pune"],
  ["AC Buses on Hire for Corporate Occasions Pune", "Executive Bus Rental Pune"],
  ["Staff Transport for Corporate Functions Pune", "Professional Event Commute Pune"],
  ["Business Conference Bus Services Pune", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Corporate Event Bus Rentals in Pune",
        "WhyChoosedescription": "eTravo offers premium buses on rent in Pune tailored for corporate events. Whether you're organizing a conference, seminar, team outing, or offsite retreat, our rental services ensure seamless group transportation with professional coordination and support."
    },
    {
        "WhyChooseheading": "Wide Range of Buses for All Group Sizes",
        "WhyChoosedescription": "From 18-seater mini-buses to 50-seater luxury coaches, our fleet accommodates all group sizes. Each bus is air-conditioned, features plush seating, and includes amenities such as Wi-Fi (on request), charging points, and bottled water—ensuring your team travels in comfort."
    },
    {
        "WhyChooseheading": "Professional Drivers for Corporate Transport",
        "WhyChoosedescription": "Our drivers are trained to serve corporate clients, maintain high safety standards, and follow event-specific schedules precisely. They are courteous, punctual, and familiar with Pune's event venues and business districts to ensure a smooth and timely journey."
    },
    {
        "WhyChooseheading": "Event-Specific Route and Time Coordination",
        "WhyChoosedescription": "We understand the importance of perfect timing in corporate events. eTravo coordinates routes, schedules, and drop-off points based on your itinerary. Our team works with your event planners to manage logistics and ensure every participant reaches on time."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Flexible Billing Options",
        "WhyChoosedescription": "Get clear, upfront quotes with no hidden charges. eTravo provides detailed billing and GST-compliant invoices, with flexible payment options for companies booking transport for events, conferences, and corporate outings."
    },
    {
        "WhyChooseheading": "24/7 Event Support and Standby Buses",
        "WhyChoosedescription": "Corporate events are dynamic, and we’re prepared. Our 24/7 support team ensures everything runs smoothly, and standby buses are available for last-minute requirements, route changes, or additional attendees."
    },
    {
        "WhyChooseheading": "Quick Booking Through App, Web, or Phone",
        "WhyChoosedescription": "Booking a bus for your corporate event is fast and simple. Use our mobile app, website, or call our team to arrange transport. We provide instant booking confirmations, driver details, and live tracking for hassle-free coordination."
    },
    {
        "WhyChooseheading": "Customized Solutions for Corporate Events",
        "WhyChoosedescription": "Each corporate event is unique, and so are our transport plans. Whether it’s a single-day seminar or a multi-day retreat, eTravo creates customized transportation packages tailored to your schedule, venue, and number of participants."
    }
]




























    }

const faqData = [
    [
        {
            question: 'Does eTravo offer bus rental services for corporate events in Pune?',
            answer: 'Yes, eTravo provides buses on rent for corporate events in Pune, including conferences, seminars, team-building outings, and off-site meetings.',
        },
        {
            question: 'What types of buses can we rent for corporate occasions in Pune?',
            answer: 'We offer a range of options including 13-seater tempo travellers, 20- to 40-seater mini-buses, and large 50+ seater luxury coaches — all well-maintained and driven by trained chauffeurs.',
        },
        {
            question: 'Can eTravo manage transportation for multiple pickup points during corporate events?',
            answer: 'Absolutely. We offer customizable pickup and drop routes across Pune, ideal for large groups traveling from different office locations or residential areas to a single event venue.',
        },
        {
            question: 'Are your event rental buses air-conditioned and comfortable for long journeys?',
            answer: 'Yes, all our rental buses for corporate events are air-conditioned and designed for comfort. Amenities include cushioned seating, bottled water, and optional onboard Wi-Fi.',
        },
        {
            question: 'How far in advance should we book a bus for a corporate event in Pune?',
            answer: 'We recommend booking at least 3–5 days in advance, especially during peak seasons or major conferences. However, we do accommodate last-minute requests based on availability.',
        },
        {
            question: 'Do you provide an event transport coordinator on the day of the event?',
            answer: 'Yes, for larger events, we assign a transport coordinator to manage vehicle dispatch, driver communication, and guest boarding to ensure seamless execution.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Kunal Deshpande',
        designation: 'Event Manager, StratEdge Corporate Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“We hired eTravo’s buses for our annual company offsite near Pune. The buses were on time, clean, and the drivers were courteous. Everything was handled professionally.”',
    },
    {
        name: 'Ms. Shruti Patel',
        designation: 'Operations Head, Vertex Innovations',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo made our conference transport stress-free. The coordination, bus quality, and punctuality exceeded our expectations. Highly recommended for corporate events.”',
    },
];


















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Pune for Corporate Events",
  "image": "https://www.etravo.in/images/keyword/bus-rent-corporate-events-pune.jpg",
  "description": "Premium bus rental services in Pune for corporate events by eTravo. Ideal for business conferences, executive travel, staff transport for functions, and AC buses for professional event commutes.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/bus-on-rent-in-pune-for-corporate-events"
  }
};






    return (
        <div>


<Helmet>
  <title>Bus On Rent in Pune for Corporate Events | Executive & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book luxury and AC buses on rent in Pune for corporate events with eTravo. Reliable staff transport, executive bus rental, and business event commute services for a seamless corporate travel experience." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busonrentinpuneforcorporate;